import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import type { GraphemeMorphemeMnemonicsPanelMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import { usePrevalentPinyin } from "@-/dev.improve.haniverse.routes.nav.app._lib.morpheme.grapheme.pinyin.prevalence";
import { toDiacriticPinyinList } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";
import { View } from "@-/com.npmjs.react-native";
import { PinyinSoundButton } from "#pinyin-sound-button";
import { usePinyinSoundButtonGate } from "#use-pinyin-sound-button-gate";

/**
 * Pinyin label paired with the unified `PinyinSoundButton`. The label is
 * inert; only the trailing speaker icon plays audio when tapped.
 */
export function CardPinyinSound({
  morphemeMnemonicsPanelMorphemeSlice,
}: {
  morphemeMnemonicsPanelMorphemeSlice: GraphemeMorphemeMnemonicsPanelMorphemeSlice;
}) {
  const studyPinyinList = usePrevalentPinyin(
    morphemeMnemonicsPanelMorphemeSlice.grapheme,
    morphemeMnemonicsPanelMorphemeSlice.pinyinList,
  );
  const pinyin = toDiacriticPinyinList(
    studyPinyinList.map(({ toneNumbersPinyin }) => toneNumbersPinyin),
  ).join(", ");
  const soundButtonGate = usePinyinSoundButtonGate(morphemeMnemonicsPanelMorphemeSlice);

  return (
    <View className="flex-row items-center gap-1">
      <Text className="text-lg" colorVariant="muted">
        {pinyin}
      </Text>
      {soundButtonGate !== null && <PinyinSoundButton gate={soundButtonGate} />}
    </View>
  );
}
